import { render, staticRenderFns } from "./CompositionBackground.vue?vue&type=template&id=5e8e7d0e&scoped=true&"
import script from "./CompositionBackground.vue?vue&type=script&lang=js&"
export * from "./CompositionBackground.vue?vue&type=script&lang=js&"
import style0 from "./CompositionBackground.vue?vue&type=style&index=0&id=5e8e7d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e7d0e",
  null
  
)

export default component.exports